import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { BehaviorSubject, Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";
import { Helper } from "src/app/core/helpers/helper";

@Injectable({
  providedIn: "root"
})
export class UsersService {
  public updateCorporate = new BehaviorSubject<any>(null);
  updateObservable = this.updateCorporate.asObservable();

  constructor(private apiService: ApiService, private helper: Helper) {}

  getUsersList(type: number, parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const url = `${apiColletions.users}/${type}`;
      this.apiService.get({ url: url, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  generateOTP(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.post({ url: apiColletions.generateOtp, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  updateDispatcherDetails(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.post({ url: apiColletions.updateProfile, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
            this.updateCorporate.next({});
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  checkUserRegistered(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.post({ url: apiColletions.checkRegisterd, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  verifyOTP(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.post({ url: apiColletions.verifyOtp, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  changePassword(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.post({ url: apiColletions.changePassword, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
